import { FC, useEffect, useState } from 'react'
import { useAppSelector } from '../../../../../../store/hooks'
import { BuilderPageSectionProps } from '../../PageBuilder.d'
import { Col, Container, Row } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'
import ImageField from '../../../../../common/forms/fields/ImageField'
import SectionValueTranslatedField from '../../SectionValueTranslatedField'

const PageSection: FC<BuilderPageSectionProps> = ({
    data,
    formikProps,
    // availablePages,
}) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [allowRemoveImage, setAllowRemoveImage] = useState(false)
    const [previewSrc, setPreviewSrc] = useState('')

    // console.log(formikProps.values.pillars)
    // console.log(formikProps.values)
    // console.log('data.pagePart: ', data.pagePart)
    // console.log(
    //     'data.pagePart.page_content_id: ',
    //     data.pagePart.page_content_id
    // )

    const newSectionId = uuidv4()

    // console.log('data.pagePart: ', data.pagePart)
    const [section, setSection] = useState(
        data.pagePart
            ? formikProps.values.pillars[data.pagePart.page_content_id]
            : {
                  page_content_id: newSectionId,
                  page_content_name: '',
                  page_content_value: '',
                  pages_id: formikProps.values.id,
                  image_url: null,
                  section_image_id: null,
              }
    )

    const {
        page_content_id: id,
        page_content_name: name,
        // page_content_value,
        // translations,
        // pages_id: pageId,
        media_store_id: section_image_id,
    } = section || {}

    // // console.log('section_image_id: ', section_image_id)

    // // TODO: Temp
    // useEffect(() => {
    //     console.log(formikProps.values.pillars)
    // }, [formikProps.values.pillars])

    useEffect(() => {
        setAllowRemoveImage(section_image_id !== null)
        setPreviewSrc(
            section_image_id
                ? `${process.env.REACT_APP_API_ROOT_URL}/media/download/${section_image_id}`
                : ''
        )
    }, [section_image_id])

    return (
        <section
            className={`page-section bg-${theme}`}
            id={`page-section-${id}`}
        >
            <Container className="px-4 px-lg-5">
                <Row>
                    <Col lg={9}>
                        <SectionValueTranslatedField
                            id={'pageHeadersTranslatedField_' + id}
                            page_content_id={id}
                            name="page_content_value"
                            label="Content"
                            formikProps={formikProps}
                            tabGroupClassName="bg-transparent"
                            tabContentClassName="bg-transparent"
                        />
                    </Col>
                    <Col lg={3}>
                        <ImageField
                            id={`sectionImageFile_${section_image_id}`}
                            name={`pillars[${id}][image_file]`}
                            formikProps={formikProps}
                            imageId={section_image_id}
                            alt={`${name} image`}
                            allowRemoveImage={allowRemoveImage}
                            setAllowRemoveImage={setAllowRemoveImage}
                            previewSrc={previewSrc}
                            setPreviewSrc={setPreviewSrc}
                            updateRecord={setSection}
                            groupClassName="shadow p-2"
                            imgStyle={{
                                maxHeight: '15rem',
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default PageSection
